/* eslint-disable no-unused-vars */
import React, {createElement, useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import {MapContext} from '../../services/map-v2/map.context';
import {HeaderContext} from '../../services/header/header.context';

import './close-markers.scss';

import ButtonSection from '../../components/buttons/button-section/button-section';
import {BottomSheetCtx} from '../../services/bottom-sheet/bottom-sheet-context';

import {ReactComponent as pointer} from '../../assets/icons/logo-public-place.svg';
import {ReactComponent as pinIcon} from '../../assets/icons/lines/system-place.svg';
import {goToDirection, subtTransportTypes} from '../../utils/utils';
import {locationCall} from '../../services/api/api.utils';
import {TimeWalkComponent} from '../time-walk/time-walk.component';
import {CloseStopsComponent} from '../close-stops/close-stops.component';


export function CloseMarkers() {
    const {search} = useLocation();
    const {getNearMarkersData, currentLocation, ready, map} = useContext(MapContext);
    const HeaderService = useContext(HeaderContext);
    const sheetService = useContext(BottomSheetCtx);
    const [nearStops, setNearStops] = useState<Array<any>>([]);
    const [transportType, setTransportType] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [title, setTitle] = useState<string>('');
    const [location, setLocation] = useState<any>({lat: 0, lng: 0});
    const [oldUrl, setUrl] = useState<string>('');
    const [selectedOption, setSelectedOption] = useState<string>('');

    const getHeaderDskInfo = () =>{
        let headerConfig = {};

        if (!isMobile) {
            headerConfig= {
                title: title,
                backIcon: true,
                pointerIcon: true,
                customClassName: {
                    'backgroundColor': 'var(--gris-fons-amb)',
                },
            };
            HeaderService.initHeader(headerConfig);
        }
    };
    const testingdata = [
        {title: 'Autobús', icon: subtTransportTypes.bus},
        {title: 'Metro', icon: subtTransportTypes.metro},
        {title: 'Tren', icon: subtTransportTypes.tren},
        {title: 'Tranvía', icon: subtTransportTypes.tranvia},
        {title: 'Otros', icon: subtTransportTypes.otros},
        {title: 'Bici', icon: subtTransportTypes.bici},
        {title: 'Moto', icon: subtTransportTypes.moto},
        {title: 'Patinete', icon: subtTransportTypes.patinete},
        {title: 'Coche', icon: subtTransportTypes.coche},
        {title: 'Taxi', icon: subtTransportTypes.taxi},
    ];
    useEffect(() => {
        if (ready) {
            const query = new URLSearchParams(search);
            const latitude = Number(query.get('lat'));
            const longitude = Number(query.get('lng'));
            setLocation({lat: latitude, lng: longitude});
            // map?.setPointer({lat: latitude, lng: longitude});
            getHeaderDskInfo();
            if (latitude && longitude && !address) {
                setUrl(window.location.href);
                locationCall(latitude, longitude).then((strAddress: any) => {
                    const titleStr = strAddress.results[0].formatted_address.split(',')[0];
                    const address = strAddress.results[0].formatted_address;
                    setTitle(titleStr);
                    setAddress(address);
                }).catch((error: Error) => {
                    setTitle('Address not found');
                    setAddress('Address not found');
                    console.error(error.message);
                });
                setSelectedOption(testingdata[0].icon);
                moveBottom();
                getNearStops(latitude, longitude);
            } else {
                if (latitude && longitude) {
                    getNearStops(latitude, longitude);
                }
                return clean();
            }
        }
    }, [window.location.href, address, transportType, ready]);


    const getNearStops = (latitude: any, longitude: any) =>{
        const stops = getNearMarkersData(latitude, longitude, transportType);
        setNearStops(stops);
    };

    // const onSelectServiceType = (value:string) => {
    //     setTransportType(value);
    //     setSelectedOption(value);
    // };

    const clean = () => {
        if (window.location.href != oldUrl) {
            setAddress('');
            setSelectedOption('');
        }
    };

    const moveBottom = () => {
        if (isMobile) {
            sheetService.setCurrentPosition(window.innerHeight/1.5);
            sheetService.setDetail(true);
        }
    };

    return <>
        <div className={ isMobile ? 'close-markers-header':'close-markers-header close-markers-header__desktop'}>
            { isMobile ? <div className="header-container">
                {createElement(pointer)}
                <h4 className="title">
                    {title}
                </h4>
            </div>: <span className="pointer">{createElement(pinIcon)}</span> }
            <span className="address">
                {address}
                <TimeWalkComponent coords={currentLocation}/>
            </span>
        </div>
        <ButtonSection
            txtButtons={['go', 'report']}
            goToDirection={() => goToDirection(location.lat, location.lng)}
        />
        <div className={ isMobile ? 'close-markers-content':'close-markers-content desktop'}>
            <CloseStopsComponent />
        </div>
    </>;
}
